import React from 'react';

import PropTypes from 'prop-types';

import clsx from 'clsx';
import _get from 'lodash/get';

import { AnimatedButton, Col, DisclaimerText, Heading, Input, Popup, Row, SubHeading } from 'reaxl';
import { StandardEmailInput } from 'reaxl-forms';

import { subscribe } from 'axl-config';

function SubscribeAlertButton(props) {
    return (
        <AnimatedButton
            bsStyle="primary"
            type="submit"
            formNoValidate
            {...props}
            key="subscribe-button"
        />
    );
}

export default function EmailSubscribeAlertForm({
    title,
    user,
    email,
    withCustomContent,
    onEmailInputChange,
    emailSubscribeSend,
}) {
    const EmailSubscribeAlertFormHeading = withCustomContent ? Heading : SubHeading;

    return (
        <Row className={clsx({ 'margin-bottom-4': withCustomContent })}>
            <Col
                xs={12}
                lg={withCustomContent ? 12 : 4}
            >
                <EmailSubscribeAlertFormHeading
                    level={withCustomContent ? 4 : 3}
                    className={clsx('padding-bottom-4 display-flex align-items-center', { 'text-gray-base': withCustomContent })}
                >
                    {title}
                </EmailSubscribeAlertFormHeading>
            </Col>

            <Col
                xs={12}
                sm={withCustomContent ? 8 : 12}
                lg={8}
            >
                <Row className="text-left margin-horizontal-0">
                    <Col
                        xs={12}
                        sm={8}
                        className={clsx('padding-right-sm-4 padding-horizontal-0', { 'padding-left-lg-2': !withCustomContent })}
                    >
                        <StandardEmailInput
                            maxLength="45"
                            name="emailAddress"
                            placeholder="Email"
                            label=""
                            required
                            value={_get(user, 'emailAddress', email)}
                            onChange={onEmailInputChange}
                        />
                        <DisclaimerText
                            className="margin-bottom-4 margin-bottom-sm-0"
                            withContrast
                        >
                            <span>
                                {subscribe.inline.privacyStatement.text}
                                <Popup
                                    width={600}
                                    height={400}
                                    url={subscribe.privacyStatement.href}
                                >
                                    <span className="text-link margin-left-1">
                                        {subscribe.privacyStatement.label}
                                    </span>
                                </Popup>
                                .
                            </span>
                        </DisclaimerText>
                    </Col>
                    <Col
                        xs={12}
                        sm={4}
                        className="padding-horizontal-0"
                        componentClass={SubscribeAlertButton}
                        {...emailSubscribeSend}
                    />
                </Row>
            </Col>
            <Input
                type="hidden"
                name="textPot"
                id="textPot"
                layout="elementOnly"
                validations={{
                    minLength: 0,
                }}
            />
        </Row>
    );
}

EmailSubscribeAlertForm.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    user: PropTypes.object,
    email: PropTypes.string,
    withCustomContent: PropTypes.bool,
    onEmailInputChange: PropTypes.func,
    emailSubscribeSend: PropTypes.object,
};
